import { render } from "./MfcContactsEntitiesByPeopleSelector.vue?vue&type=template&id=6ea84875"
import script from "./MfcContactsEntitiesByPeopleSelector.vue?vue&type=script&lang=js"
export * from "./MfcContactsEntitiesByPeopleSelector.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__